import type { LbPostEventOld } from '../types';
import { LbEventPhase, LbEventSubType, LbEventType } from '../types';

export const eventTypeMapping: Record<
  string,
  [eventType: LbEventType, eventSubType?: LbEventSubType, eventExtraSubType?: LbEventSubType]
> = {
  '1': [LbEventType.YELLOW_CARD],
  '1_A': [LbEventType.YELLOW_CARD, LbEventSubType.FOUL_PLAY],
  '1_B': [LbEventType.YELLOW_CARD, LbEventSubType.ROUGH_PLAY],
  '1_C': [LbEventType.YELLOW_CARD, LbEventSubType.TRIP_OPPONENT],
  '1_D': [LbEventType.YELLOW_CARD, LbEventSubType.DANGEROUS_PLAY],
  '1_E': [LbEventType.YELLOW_CARD, LbEventSubType.TIME_WASTING],
  '1_F': [LbEventType.YELLOW_CARD, LbEventSubType.KICKING_BALL_AWAY],
  '1_G': [LbEventType.YELLOW_CARD, LbEventSubType.HOLDING_OPPONENT],
  '1_H': [LbEventType.YELLOW_CARD, LbEventSubType.IMPROPER_CONDUCT],
  '1_I': [LbEventType.YELLOW_CARD, LbEventSubType.DISSENT],
  '1_J': [LbEventType.YELLOW_CARD, LbEventSubType.HANDBALL],
  '1_K': [LbEventType.YELLOW_CARD, LbEventSubType.PUSHING_OPPONENT],
  '1_L': [LbEventType.YELLOW_CARD, LbEventSubType.FREE_KICK_DISTANCE],
  '1_M': [LbEventType.YELLOW_CARD, LbEventSubType.CHARGING_OPPONENT],
  '1_N': [LbEventType.YELLOW_CARD, LbEventSubType.VIOLENT_PLAY],
  '1_Q': [LbEventType.YELLOW_CARD, LbEventSubType.ENTERING_WITHOUT_PERMISSION],
  '1_R': [LbEventType.YELLOW_CARD, LbEventSubType.FREE_KICK_DISTANCE],
  '1_S': [LbEventType.YELLOW_CARD],
  '2': [LbEventType.RED_CARD],
  '2_A': [LbEventType.RED_CARD, LbEventSubType.FOUL_PLAY],
  '2_B': [LbEventType.RED_CARD, LbEventSubType.ROUGH_PLAY],
  '2_C': [LbEventType.RED_CARD, LbEventSubType.TRIP_OPPONENT],
  '2_D': [LbEventType.RED_CARD, LbEventSubType.DANGEROUS_PLAY],
  '2_E': [LbEventType.RED_CARD, LbEventSubType.TIME_WASTING],
  '2_F': [LbEventType.RED_CARD, LbEventSubType.KICKING_BALL_AWAY],
  '2_G': [LbEventType.RED_CARD, LbEventSubType.HOLDING_OPPONENT],
  '2_H': [LbEventType.RED_CARD, LbEventSubType.IMPROPER_CONDUCT],
  '2_I': [LbEventType.RED_CARD, LbEventSubType.DISSENT],
  '2_J': [LbEventType.RED_CARD, LbEventSubType.HANDBALL],
  '2_K': [LbEventType.RED_CARD, LbEventSubType.PUSHING_OPPONENT],
  '2_L': [LbEventType.RED_CARD, LbEventSubType.FREE_KICK_DISTANCE],
  '2_M': [LbEventType.RED_CARD, LbEventSubType.CHARGING_OPPONENT],
  '2_N': [LbEventType.RED_CARD, LbEventSubType.VIOLENT_PLAY],
  '2_Q': [LbEventType.RED_CARD, LbEventSubType.ENTERING_WITHOUT_PERMISSION],
  '2_R': [LbEventType.RED_CARD, LbEventSubType.FREE_KICK_DISTANCE],
  '2_P': [LbEventType.RED_YELLOW_CARD],
  '3': [LbEventType.GOAL],
  '3_M': [LbEventType.GOAL, LbEventSubType.PENALTY_SECOND_MARK],
  '3_O': [LbEventType.GOAL, LbEventSubType.OWN],
  '3_P': [LbEventType.GOAL, LbEventSubType.PENALTY],
  '3_0_1': [LbEventType.GOAL, null, LbEventSubType.DIRECT_FREE_KICK],
  '3_0_2': [LbEventType.GOAL, null, LbEventSubType.INDIRECT_FREE_KICK],
  '3_0_5': [LbEventType.GOAL, null, LbEventSubType.CORNER],
  '3_0_F': [LbEventType.GOAL, null, LbEventSubType.FAST_ATTACK],
  '4': [LbEventType.SUBSTITUTION],
  '4_Z': [LbEventType.SUBSTITUTION, LbEventSubType.HALF_TIME],
  '5_7': [LbEventType.PENALTY, LbEventSubType.MISSED, LbEventSubType.SAVED],
  '5_8': [LbEventType.PENALTY, LbEventSubType.MISSED, LbEventSubType.CROSSBAR],
  '5_D': [LbEventType.PENALTY, LbEventSubType.SCORED],
  '5_I': [LbEventType.PENALTY, LbEventSubType.MISSED, LbEventSubType.WIDE],
  '5_T': [LbEventType.PENALTY, LbEventSubType.MISSED, LbEventSubType.POST],
  '5_W': [LbEventType.PENALTY, LbEventSubType.MISSED],
  '6': [LbEventType.SHOT_BLOCKED],
  '7': [LbEventType.SHOT_WIDE],
  '7_0_1': [LbEventType.SHOT_WIDE, null, LbEventSubType.DIRECT_FREE_KICK],
  '7_0_2': [LbEventType.SHOT_WIDE, null, LbEventSubType.INDIRECT_FREE_KICK],
  '7_B': [LbEventType.SHOT_WIDE, LbEventSubType.CROSSBAR],
  '7_B_1': [LbEventType.SHOT_WIDE, LbEventSubType.CROSSBAR, LbEventSubType.DIRECT_FREE_KICK],
  '7_B_2': [LbEventType.SHOT_WIDE, LbEventSubType.CROSSBAR, LbEventSubType.INDIRECT_FREE_KICK],
  '7_T': [LbEventType.SHOT_WIDE, LbEventSubType.POST],
  '7_T_1': [LbEventType.SHOT_WIDE, LbEventSubType.POST, LbEventSubType.DIRECT_FREE_KICK],
  '7_T_2': [LbEventType.SHOT_WIDE, LbEventSubType.POST, LbEventSubType.INDIRECT_FREE_KICK],
  '8': [LbEventType.SHOT_ON_GOAL],
  '8_B': [LbEventType.SHOT_ON_GOAL, LbEventSubType.CROSSBAR],
  '8_T': [LbEventType.SHOT_ON_GOAL, LbEventSubType.POST],
  '8_0_1': [LbEventType.SHOT_ON_GOAL, null, LbEventSubType.DIRECT_FREE_KICK],
  '8_0_2': [LbEventType.SHOT_ON_GOAL, null, LbEventSubType.INDIRECT_FREE_KICK],
  '9': [LbEventType.OFFSIDE],
  '10': [LbEventType.CORNER],
  '10_C': [LbEventType.CORNER, null, LbEventSubType.CROSS],
  '10_W': [LbEventType.CORNER, LbEventSubType.MISSED],
  '11': [LbEventType.FOUL],
  '11_0_1': [LbEventType.FOUL, null, LbEventSubType.DIRECT_FREE_KICK],
  '11_H': [LbEventType.FOUL, LbEventSubType.HANDBALL],
  '11_H_P': [LbEventType.FOUL, LbEventSubType.HANDBALL, LbEventSubType.PENALTY],
  '11_0_2': [LbEventType.FOUL, null, LbEventSubType.INDIRECT_FREE_KICK],
  '11_0_P': [LbEventType.FOUL, null, LbEventSubType.PENALTY],
  '11_F': [LbEventType.FOUL, LbEventSubType.SIMULATION],
  '12': [LbEventType.ASSIST],
  '13': [LbEventType.START_PHASE],
  '14': [LbEventType.END_PHASE],
  '14_E': [LbEventType.END_PHASE, LbEventSubType.FULL_TIME],
  '15': [LbEventType.EXTRA_TIME],
  '16_A': [LbEventType.PAUSE, LbEventSubType.PAUSED],
  '16_U': [LbEventType.PAUSE, LbEventSubType.SUSPENDED],
  '16_X': [LbEventType.PAUSE, LbEventSubType.TIMEOUT],
  '17': [LbEventType.RESUME],
  '18': [LbEventType.CHANGE_PHASE],
  '19': [LbEventType.INJURY_TIME],
  '20': [LbEventType.RED_YELLOW_CARD],
  '30': [LbEventType.FREE_KICK],
  '30_0_W': [LbEventType.FREE_KICK, LbEventSubType.MISSED],
  '30_1': [LbEventType.FREE_KICK, LbEventSubType.DIRECT_FREE_KICK],
  '30_2': [LbEventType.FREE_KICK, LbEventSubType.INDIRECT_FREE_KICK],
  '30_C': [LbEventType.FREE_KICK, LbEventSubType.CROSS],
  '32': [LbEventType.SAVE],
  '32_20': [LbEventType.SAVE, LbEventSubType.GOALKEEPER],
  '32_26': [LbEventType.SAVE, LbEventSubType.FREE_KICK],
  '32_27': [LbEventType.SAVE, LbEventSubType.PENALTY],
  '32_28': [LbEventType.SAVE, LbEventSubType.CORNER],
  '32_29': [LbEventType.SAVE, LbEventSubType.FAST_ATTACK],
  '32_0_21': [LbEventType.SAVE, LbEventSubType.WOODWORK],
  '40': [LbEventType.DISALLOWED_GOAL],
  '41': [LbEventType.VAR],
  '51': [LbEventType.THROW_IN],
  '51_C': [LbEventType.THROW_IN, null, LbEventSubType.CROSS],
  '52': [LbEventType.PASS, LbEventSubType.COMPLETED],
  '52_C': [LbEventType.PASS, LbEventSubType.COMPLETED, LbEventSubType.CROSS],
  '52_K': [LbEventType.PASS, LbEventSubType.COMPLETED, LbEventSubType.GOAL_KICK],
  '52_L': [LbEventType.PASS, LbEventSubType.COMPLETED, LbEventSubType.LONG],
  '52_M': [LbEventType.PASS, LbEventSubType.COMPLETED, LbEventSubType.MEDIUM],
  '52_S': [LbEventType.PASS, LbEventSubType.COMPLETED, LbEventSubType.SHORT],
  '52_R': [LbEventType.PASS, LbEventSubType.COMPLETED, LbEventSubType.CLEARANCE],
  '52_0_W': [LbEventType.PASS, LbEventSubType.FAILED],
  '52_K_W': [LbEventType.PASS, LbEventSubType.FAILED, LbEventSubType.GOAL_KICK],
  '52_L_W': [LbEventType.PASS, LbEventSubType.FAILED, LbEventSubType.LONG],
  '52_M_W': [LbEventType.PASS, LbEventSubType.FAILED, LbEventSubType.MEDIUM],
  '52_S_W': [LbEventType.PASS, LbEventSubType.FAILED, LbEventSubType.SHORT],
  '52_C_W': [LbEventType.PASS, LbEventSubType.FAILED, LbEventSubType.CROSS],
  '52_R_W': [LbEventType.PASS, LbEventSubType.FAILED, LbEventSubType.CLEARANCE],
  '54': [LbEventType.FAST_ATTACK],
  '62_I': [LbEventType.ATTACK, LbEventSubType.CAUSING_GOAL],
  '62_I_C': [LbEventType.ATTACK, LbEventSubType.CAUSING_GOAL, LbEventSubType.CENTER],
  '62_I_A': [LbEventType.ATTACK, LbEventSubType.CAUSING_GOAL, LbEventSubType.LEFT],
  '62_I_B': [LbEventType.ATTACK, LbEventSubType.CAUSING_GOAL, LbEventSubType.RIGHT],
  '62_0_C': [LbEventType.ATTACK, null, LbEventSubType.CENTER],
  '62_0_A': [LbEventType.ATTACK, null, LbEventSubType.LEFT],
  '62_0_B': [LbEventType.ATTACK, null, LbEventSubType.RIGHT],
  '55': [LbEventType.TACKLE],
  '55_W': [LbEventType.TACKLE, LbEventSubType.FAILED],
  '55_C': [LbEventType.TACKLE, LbEventSubType.COMPLETED],
  '63': [LbEventType.SOLO_RUN],
  '64': [LbEventType.RECOVERED_BALL],
  '71': [LbEventType.DROPPED_BALL],
  '80_K': [LbEventType.GOAL_OPPORTUNITY],
  '80_F': [LbEventType.FULL_TIME],
  '80_L': [LbEventType.CORNER_AWARDED],
  '80_I': [LbEventType.DANGEROUS_ATTACK],
  '80_A': [LbEventType.PENALTY_AWARDED],
  '80_H': [LbEventType.PENALTY_AWARDED],
  '1002': [LbEventType.ORGANIZED_ATTACK],
  '1003': [LbEventType.FAST_ACTION],
};

export const eventPhaseMapping = {
  1: LbEventPhase.FIRST_HALF,
  2: LbEventPhase.SECOND_HALF,
  3: LbEventPhase.EXTRA_TIME_FIRST_HALF,
  4: LbEventPhase.EXTRA_TIME_SECOND_HALF,
  5: LbEventPhase.PENALTY,
};

export const getEventKey = (event: LbPostEventOld): string => {
  let key = event.eventType;
  if (event.eventSubType || event.eventExtraSubType) {
    key += `_${event.eventSubType ?? '0'}`;
  }
  if (event.eventExtraSubType) {
    key += `_${event.eventExtraSubType}`;
  }
  return key;
};
